<template>
  <div class="loading__dialog" v-show="vmVisible">
    <div class="loading__dialog__content">
      <div class="loading__dialog__content__left">
        <img src="./img/left.png">
      </div>
      <div class="loading__dialog__content__top">
        <img src="./img/top.png">
      </div>
      <div class="loading__dialog__content__bottom">
        <img src="./img/bottom.png">
      </div>
      <p class="loading__dialog__content__text">正在加载…</p>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      vmVisible:false
    }
  },
  methods:{
    show(){
      this.vmVisible = true
    },
    hide(){
      this.vmVisible = false
    }
  }
}
</script>
<style lang="less" scoped>
.loading__dialog{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-color:rgba(0, 0, 0, .4);
  display: flex;
  justify-content: center;
  align-items: center;
  &__content{
    width:132px;
    height: 120px;
    position: relative;
    &__left{
      position: absolute;
      top:0;
      left:0;
      width: 86px;
      height: 86px;
      animation:rotateX 3s linear infinite;
    }
    &__top{
      position: absolute;
      top:-17px;
      right:3px;
      width: 54px;
      height: 54px;
      animation:rotateY 1.5s linear infinite;
    }
    &__bottom{
      position: absolute;
      bottom:9px;
      right:-8px;
      width: 65px;
      height: 65px;
      animation:rotateY 2s linear infinite;
    }
    img{
      width: 100%;
      height: 100%;
    }
    &__text{
      padding: 0;
      margin: 0;
      position: absolute;
      bottom:-14px;
      left:0;
      width: 100%;
      text-align: center;
      font-size:16px;
      color:#fff;
    }
  }
}

@keyframes rotateX{
  from{
    transform: rotate(0deg)
  }
  to{
    transform: rotate(360deg)
  }
}
@keyframes rotateY{
  from{
    transform: rotate(0deg)
  }
  to{
    transform: rotate(-360deg)
  }
}
</style>